import clsx from "clsx";
import NextLink from "next/link";
import { FC, HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { ArrowDown } from "icons";

interface MegaMenuResourceProps extends HTMLAttributes<HTMLElement> {
  href?: string;
  children: ReactNode;
  isActive?: boolean;
}

const MegaMenuResource: FC<MegaMenuResourceProps> = ({ href = "", isActive = false, children, ...rest }) => {
  const baseClasses =
    "flex items-center justify-center text-base font-semibold text-inherit gap-[6px] px-3 transition-colors  group";

  const activeClasses = clsx({
    "text-fog-50 [&>svg]:stroke-fog-50": isActive,
  });

  const arrowClasses = clsx(
    "pointer-events-none relative bottom-[1px] m-auto h-[12px] w-auto transition-all duration-300 ease-in-out",
    {
      "-rotate-180": isActive,
    }
  );

  return href ? (
    <NextLink href={href} className={twMerge(baseClasses, activeClasses)} type="link" {...rest}>
      {children}
    </NextLink>
  ) : (
    <button className={twMerge(baseClasses, activeClasses)} {...rest}>
      {children}
      <ArrowDown className={arrowClasses} />
    </button>
  );
};

export { MegaMenuResource };
